import React from 'react'

import Navbar from '../components/Navbar'

import Form from '../components/Form/Form'

import { formData, sendInfo } from '../data/cityDevelopmentData'
import { formAnalysis } from '../helpers/analysis'

const CityDevelopment = () => {
    return (
        <div className="background">
            <Navbar />
            <Form formData={formData} sendInfo={sendInfo} analysis={formAnalysis} />
        </div>
    )
}

export default CityDevelopment